import { THEMES } from "../../constants/themes";

export function ThemePicker({ current, onSelect }) {
  const groups = ["Colour", "Seasonal", "Mood"];
  const grouped = groups.reduce((acc, g) => {
    acc[g] = Object.entries(THEMES).filter(([, t]) => t.group === g);
    return acc;
  }, {});
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1.1rem" }}>
      {groups.map(g => (
        <div key={g}>
          <div style={{ fontSize: ".72rem", fontWeight: 800, textTransform: "uppercase", letterSpacing: ".08em", color: "var(--muted)", marginBottom: ".5rem" }}>{g}</div>
          <div className="theme-grid">
            {grouped[g].map(([key, t]) => (
              <div key={key} className={`theme-opt ${current === key ? "chosen" : ""}`} onClick={() => onSelect(key)}>
                <div className="theme-swatch" style={{ background: t.hero }} />
                <div className="theme-label">{t.label}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
